import {AnimatedFormHelperText, MeinCheckbox} from '@components/@shared';
import {IFieldError} from '@core/exceptions';
import {CheckboxProps, FormControlLabel, FormGroup} from '@mui/material';
import classNames from 'classnames';
import {FC, ReactNode, forwardRef} from 'react';
import styles from './MeinCheckboxLabelled.module.css';

interface IProps extends Omit<CheckboxProps, 'value' | 'defaultValue'> {
    label: ReactNode;
    helperText?: string;
    error?: IFieldError | boolean;
    value?: boolean;
    defaultValue?: boolean;
}

export const MeinCheckboxLabelled: FC<IProps> = forwardRef(
    function MeinCheckboxLabelled(
        {
            className,
            label,
            helperText,
            error,
            value,
            defaultValue,
            ...rest
        }: IProps,
        ref,
    ) {
        return (
            <FormGroup>
                <FormControlLabel
                    control={<MeinCheckbox ref={ref} {...rest} />}
                    defaultChecked={defaultValue}
                    checked={value}
                    className={classNames(styles.label, className)}
                    label={label}
                />
                <AnimatedFormHelperText
                    className={styles.helperText}
                    helperText={helperText}
                    error={!!error}
                />
            </FormGroup>
        );
    },
);
